import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT, ModalService } from '@cfp/core';
import { PortfolioDTO } from 'csr-asset-app';
import { AddBuildingOptions } from './add-building-options';

@Injectable({
  providedIn: 'root'
})
export class AddBuildingService {
  public readonly loading = signal<boolean>(false);

  private readonly modalService = inject(ModalService);
  private readonly environment = inject(ENVIRONMENT);
  private readonly router = inject(Router);

  public async addBuilding(
    portfolioId: number,
    portfolio: PortfolioDTO,
    addBuildingOptions?: AddBuildingOptions
  ): Promise<void> {
    addBuildingOptions = { module: 'energy', ...addBuildingOptions };
    if (this.environment.useDeprecatedAddBuildingPage === true) {
      this.router.navigateByUrl(`/energy/${portfolioId}/add-building`);
    } else {
      this.showAddBuildingSidePanel(portfolioId, portfolio, addBuildingOptions);
    }
  }

  private async showAddBuildingSidePanel(
    portfolioId: number,
    portfolio: PortfolioDTO,
    addBuildingOptions: AddBuildingOptions
  ): Promise<void> {
    this.loading.set(true);
    const { AddBuildingSidePanel } = await import(
      /* webpackChunkName: "add-building" */
      '@cfp/domains/portfolio/add-building/components'
    );

    this.modalService.show(AddBuildingSidePanel, {
      initialState: {
        portfolioId: portfolioId,
        isDemoPortfolio: portfolio.isDemoPortfolio,
        addBuildingOptions
      },
      class: 'modal-dialog-scrollable modal-dialog-slideout modal-sm',
      ignoreBackdropClick: true,
      keyboard: false
    });
    this.loading.set(false);
  }
}
